import { useState } from 'react';

/**
 * Pull-to-refresh glue: runs the given refetchers together and tracks a single
 * `refreshing` flag for a RefreshControl. Individual failures are swallowed so
 * one stale query can't wedge the spinner.
 */
export function useRefresh(refetchers: (() => Promise<unknown>)[]) {
  const [refreshing, setRefreshing] = useState(false);
  const onRefresh = () => {
    setRefreshing(true);
    Promise.all(refetchers.map((refetch) => refetch().catch(() => undefined))).finally(() =>
      setRefreshing(false),
    );
  };
  return { refreshing, onRefresh };
}
